// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_MSGCODE_INFO,
    APP_MSGCODE_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: ''
}

const getters = {
    getMsgCode: state => state.apiInfo
}

const actions = {
    getMsgCode({commit}, options) {
        var uri = API_AI + "/h5/auth/sendLoginCaptcha"
        return new Promise((resolve, reject) => {
            Vue.http.post(uri,{
                mobilePhone : options.data.mobileData
            }).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_MSGCODE_INFO, res)
            }, (err) => {
                commit(APP_MSGCODE_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_MSGCODE_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_MSGCODE_FAILURE](state, data) {
        state.apiInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/getCode.js